export default {"src":"/_next/static/media/minidiftman-hat.ddb3341f.svg","height":73,"width":73,"blurWidth":0,"blurHeight":0};